<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <span *ngIf="housingUnitId > 0">
        <mat-icon>edit</mat-icon> Edit Housing Unit <span>OHA Id: {{housingUnitId}}</span>
      </span>
      <span *ngIf="housingUnitId == 0">
        <mat-icon>add</mat-icon> Add Housing Unit
      </span>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">&nbsp;</div>
</div>

<div *ngIf="!loading">
  <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
    <!-- Housing Unit -->
    <mat-tab label="Housing Unit">
      <br />
      <form [formGroup]="housingUnitForm" class="form-field-full">
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Contact Information</span>
              </mat-card-title>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Name" formControlName="contactName">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Phone" formControlName="contactPhone">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Cell Phone" formControlName="contactCellPhone">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Contact Email" formControlName="contactEmail">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Preferred Contact Method" formControlName="preferredContactMethod">
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Physical Address</span>
              </mat-card-title>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Address" formControlName="address1">
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="25" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="City" formControlName="city">
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="State" formControlName="state">
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Zip" formControlName="zip">
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label>County</mat-label>
                    <mat-select id="county" name="county" formControlName="county">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.text}}">{{item.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Mailing Address</span>
              </mat-card-title>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Mailing Address" formControlName="mailingAddress">
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Mailing City" formControlName="mailingCity">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Mailing State" formControlName="mailingState">
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Mailing Zip" formControlName="mailingZip">
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <br />
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Housing Unit Information</span>
              </mat-card-title>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Owner First Name" formControlName="ownerFirstName">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Owner Last Name" formControlName="ownerLastName">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Owner Email" formControlName="ownerEmail">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Tax Lot" formControlName="taxLot">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Tax Lot Id" formControlName="taxLotId">
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Latitude" formControlName="latitude">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Longitude" formControlName="longitude">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Acres" formControlName="acres">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Map" formControlName="map">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Municipality" formControlName="municipality">
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Accepted Services" formControlName="acceptedServices">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Unit Type" formControlName="unitType">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Unit Number" formControlName="unitNumber">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Source ID" formControlName="sourceID">
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <input matInput placeholder="Housing Unit Data Source" formControlName="housingUnitDataSource">
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <br />
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card fxFlex="100">
              <mat-card-title>
                <span>Housing Unit Comments</span>
              </mat-card-title>
              <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <textarea matInput placeholder="Comments" formControlName="comments"></textarea>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <textarea matInput placeholder="Source Comments" formControlName="sourceComments"></textarea>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <textarea matInput placeholder="OHA Comments" formControlName="ohaComments"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>

        <!-- buttons -->
        <div fxLayout="row" fxLayoutAlign="none" fxLayoutGap="8px">
          <button mat-raised-button [disabled]="processing || loading || authService.isReadOnly()" color="primary" (click)="onSubmit()" title="{{buttonText}}">{{buttonText}}</button>
          &nbsp;
          <button mat-raised-button color="warn" [disabled]="processing || loading || authService.isReadOnly()" (click)="delete()" *ngIf="housingUnitId  > 0" title="{{buttonText}}">Delete Housing
            Unit</button>
          &nbsp;
          <em fxHide fxShow.gt-sm><small *ngIf="housingUnitId > 0">Last updated on {{housingUnit?.lastUpdated}} by
              {{housingUnit?.lastUpdatedBy}}</small>
          </em>
        </div>
      </form>
    </mat-tab>

    <!-- Well -->
    <mat-tab label="Wells" *ngIf="housingUnitId > 0">
      <br />
      <housingunit-associations [housingUnitId]="housingUnitId" [wells]="true"></housingunit-associations>
    </mat-tab>

    <!-- Water systems -->
    <mat-tab label="Water Systems" *ngIf="housingUnitId > 0">
      <br />
      <water-systems [housingUnitId]="housingUnitId"></water-systems>
    </mat-tab>

    <!-- Households -->
    <mat-tab label="Households" *ngIf="housingUnitId > 0">
      <br />
      <housingunit-associations [housingUnitId]="housingUnitId" [households]="true"></housingunit-associations>
    </mat-tab>

    <!-- Treatment -->
    <mat-tab label="Treatments" *ngIf="housingUnitId > 0">
      <br />
      <housingunit-treatments [housingUnitId]="housingUnitId" [address]="address"></housingunit-treatments>
    </mat-tab>

  </mat-tab-group>
</div>